<template>
  <div class="card card-custom">
    <!--begin::Header-->
    <div class="card-header align-items-center px-4 py-3">
      <div class="text-left flex-grow-1"></div>
      <div class="text-center flex-grow-1">
        <div class="text-dark-75 font-weight-bold font-size-h5">Сообщения</div>
      </div>
      <div class="text-right flex-grow-1"></div>
    </div>
    <!--end::Header-->

    <!--begin::Body-->
    <div class="card-body">
      <perfect-scrollbar style="max-height: 45vh; position: relative;" ref="scroll">
        <div class="messages" ref="messages" v-if="messages.length > 0">
          <template v-for="message in messages">
            <template v-if="message.author">
              <div class="d-flex flex-column mb-5 align-items-end" :key="message.id">
                <div class="d-flex align-items-center">
                  <div>
                    <span
                      class="text-muted font-size-sm"
                    >{{formatDateTime(message.created_at)}}&nbsp;&nbsp;</span>
                    <a class="text-dark-75 text-hover-primary font-weight-bold font-size-h6">Вы</a>
                  </div>
                  <div class="symbol symbol-circle symbol-40 ml-3"></div>
                </div>
                <div
                  class="mt-2 rounded p-5 bg-light-primary text-dark-50 font-weight-bold font-size-lg text-right max-w-400px"
                >{{message.body}}</div>
              </div>
            </template>
            <template v-else>
              <div class="d-flex flex-column mb-5 align-items-start" :key="message.id">
                <div class="d-flex align-items-center">
                  <div>
                    <a
                      class="text-dark-75 text-hover-primary font-weight-bold font-size-h6"
                    >{{(message.sender || {}).name}}</a>
                    <span
                      class="text-muted font-size-sm"
                    >&nbsp;&nbsp;{{formatDateTime(message.created_at)}}</span>
                  </div>
                </div>
                <div
                  class="mt-2 rounded p-5 bg-light-success text-dark-50 font-weight-bold font-size-lg text-left max-w-400px"
                >{{message.body}}</div>
              </div>
            </template>
          </template>
        </div>
        <div v-else>Нет сообщений</div>
      </perfect-scrollbar>
    </div>
    <!--end::Body-->

    <!--begin::Footer-->
    <div class="card-footer align-items-center">
      <v-form ref="form" v-model="valid" :lazy-validation="false">
        <v-textarea
          name="message"
          label="Сообщение"
          value
          hint
          :rules="messageRules"
          v-model="form.message"
          @keydown.ctrl.enter.exact="onSubmit"
        ></v-textarea>
        <div class="d-flex align-items-center justify-content-between mt-5">
          <div class="mr-3"></div>
          <div>
            <v-btn type="button" color="primary" @click="onSubmit" :loading="submitting">Отправить</v-btn>
          </div>
        </div>
      </v-form>
    </div>
    <!--end::Footer-->
  </div>
</template>

<script>
import moment from "moment";
moment.locale("ru");
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "messages",
  metaInfo: {
    title: "Сообщения"
  },
  components: {},
  data() {
    return {
      valid: true,
      messageRules: [v => !!v || "не может быть пустым"],
      loading: true,
      submitting: false,
      messages: [],
      form: {
        message: null
      }
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Сообщения" }]);
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$api["contractor/messages"]
        .select()
        .then(response => {
          this.messages = response.data.items;
          this.$nextTick(() => {
            this.$refs.scroll.$el.scrollTop = this.$refs.messages.clientHeight;
          });
          this.markReaded();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatDateTime(time) {
      return moment(time).fromNow();
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        message: null
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.sendMessage(this.form.message);
      }
    },
    sendMessage(message) {
      this.submitting = true;
      this.$api["contractor/messages"]
        .send({ body: message })
        .then(() => {
          this.$toast.success("Сообщение отправлено.");
          this.resetForm();
          this.fetchData();
        })
        .catch(error => {
          this.$toast.error(error.response.data.errors.base.join(", "), {
            icon: "fa-exclamation-circle"
          });
        })
        .finally(() => (this.submitting = false));
    },
    markReaded() {
      this.messages.filter(m => !m.readed && !m.author).forEach(m => {
        this.$api["contractor/messages"]
        .markReaded(m.id)
        .then(() => {

        })
        .catch(error => {
          this.$toast.error(error.response.data.errors.base.join(", "), {
            icon: "fa-exclamation-circle"
          });
        })
      })
    }
  }
};
</script>
